export default "__VITE_ASSET__cfa8aQUC__"